import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import Menu from '../Menu'

import styles from './styles'


const decorators = [
  memoized,
]

function Sidebar(props) {
  const { isOpen, routes, otherRoutes } = props

  const handleNavClose = () => {
    props.onPressClose()
  }

  return (
    <nav className={classnames(isOpen && 'open')}>
      <Menu
        routesInfos={routes}
        otherRoutesInfos={otherRoutes}
        enableTab={isOpen}
        onTouchEnd={handleNavClose}
        onClose={handleNavClose}
      />
      <style jsx>{styles}</style>
    </nav>
  )
}

Sidebar.propTypes = {
  isOpen: PropTypes.bool,
  onPressClose: PropTypes.func,
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      route: PropTypes.string,
      link: PropTypes.string,
    })
  ),
  otherRoutes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      route: PropTypes.string,
      link: PropTypes.string,
    })
  ),
}

Sidebar.defaultProps = {
  isOpen: true,
  onPressClose: () => {
  },
  routes: [],
  otherRoutes: [],
}

Sidebar = chainDecorators(decorators, Sidebar)

export default Sidebar
